import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }

import {Deliverable as DeliverableClient} from "@/endpoints/rutsolve/gql/resolvers/deliverable"
  import {onBeforeMount, ref} from "vue"
  import {Deliverable} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'deliverable',
  props: {
    deliverableID: {
      default: null,
      required: true,
      type: String
    }
  },
  setup(__props) {

  const props = __props

  const error = ref<Error>(null)
  const deliverableClient = new DeliverableClient()
  const deliverable = ref<Deliverable>(null)

  onBeforeMount( () => {
    read()
  })

  async function read() {
    try {
      deliverable.value = await deliverableClient.summary(props.deliverableID)
    } catch(e) {
      error.value = e
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _cache[12] || (_cache[12] = _createElementVNode("h1", null, " Deliverable ", -1)),
      (deliverable.value)
        ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[1] || (_cache[1] = _createElementVNode("th", null, " Type ", -1)),
                _createElementVNode("td", null, _toDisplayString(deliverable.value.type), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("th", null, " Trademark ", -1)),
                _createElementVNode("td", null, [
                  (deliverable.value.trademark)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(deliverable.value.trademark.name), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[3] || (_cache[3] = _createElementVNode("th", null, " Name ", -1)),
                _createElementVNode("td", null, _toDisplayString(deliverable.value.name), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[4] || (_cache[4] = _createElementVNode("th", null, " EAN ", -1)),
                _createElementVNode("td", null, _toDisplayString(deliverable.value.ean), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("th", null, " Description ", -1)),
                _createElementVNode("td", null, _toDisplayString(deliverable.value.description), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("th", null, " Unit ", -1)),
                _createElementVNode("td", null, _toDisplayString(deliverable.value.unit), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[7] || (_cache[7] = _createElementVNode("th", null, " Currency ", -1)),
                _createElementVNode("td", null, _toDisplayString(deliverable.value.currency), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[8] || (_cache[8] = _createElementVNode("th", null, " Net Unit Price ", -1)),
                _createElementVNode("td", null, [
                  (deliverable.value.unitPrice && deliverable.value.unitPrice.net)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(Number(deliverable.value.unitPrice.net).toFixed(2)), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[9] || (_cache[9] = _createElementVNode("th", null, " Gross Unit Price ", -1)),
                _createElementVNode("td", null, [
                  (deliverable.value.unitPrice && deliverable.value.unitPrice.gross)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(Number(deliverable.value.unitPrice.gross).toFixed(2)), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[10] || (_cache[10] = _createElementVNode("th", null, " VAT Rate ", -1)),
                _createElementVNode("td", null, [
                  (deliverable.value.vatRate)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(Number(deliverable.value.vatRate).toFixed(2)) + "% ", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[11] || (_cache[11] = _createElementVNode("th", null, " Memorandum ", -1)),
                _createElementVNode("td", null, _toDisplayString(deliverable.value.memorandum), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (error.value)
        ? (_openBlock(), _createBlock(ErrorModal, {
            key: 1,
            error: error.value,
            "onUpdate:error": _cache[0] || (_cache[0] = ($event: any) => ((error).value = $event))
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})